export const PR_SITE_URL = 'https://www.roomstogo.pr'

export const getCanonicalUrl = pathname => {
  const path = pathname || '/'
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${PR_SITE_URL}${normalizedPath}`
}
